class KovCheckbox {
  constructor($filter, $scope) {
    'ngInject'
    this.$scope = $scope;

    this.checkedIcon = require('./img/checkbox-checked.svg');
    this.uncheckedIcon = require('./img/checkbox.svg')
  }

  onClick() {
    this.model = !this.model;
    this.$scope.$emit('onChange', this.model, this.sId);
  }
}

module.exports = {
  template: require('./kovCheckbox.html'),
  replace: false,
  transclude: true,
  bindings: {
    sId: '@?',
    model: '<sModel',
    label: '@sLabel',
    disabled: '<sDisabled'
  },
  controllerAs: 'ctrl',
  controller: KovCheckbox
};